// extracted by mini-css-extract-plugin
export default {"EmptyLeadsList":"EmptyLeadsList-module-a0c9bf22d748e51198c0"};